/* eslint-disable */

import React, { useEffect } from "react";
import { useState } from "react";
import RaindropButton, {
  ButtonStyle,
} from "../../../ui-components/raindrop-button/raindrop-button.tsx";
import RaindropInput from "../../../ui-components/raindrop-input/raindrop-input.tsx";
import {
  fetchGraphQL,
  fetchOrganisationIngestPost,
} from "../../../services/api-raindrop";
import { useNavigate } from "react-router-dom";
import RaindropInputTextArea from "../../../ui-components/raindrop-input-text-area/raindrop-input-text-area.tsx";
import FlexCol from "../../../ui-components/flex-col/flex-col.tsx";
import RaindropInputDropdown from "../../../ui-components/raindrop-input-dropdown/raindrop-input-dropdown.tsx";
import { isProductionEnvironment } from "../../../services/environment.js";

const FormNewOrganisationIngesting = () => {
  const navigate = useNavigate();

  const [charityNumber, setCharityNumber] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const onCreate = () => {
    setIsLoading(true);
    fetchOrganisationIngestPost({
      charityNumber: charityNumber,
    })
      .then((organisation) => {
        navigate(`/nimbus/organisations/${organisation.result.id}`);
      })
      .finally(() => {
        console.log("🟢 (RD-117) - Organisation created");
        setIsLoading(false);
      });
  };
  return (
    <>
      <RaindropInput
        label={"Charity Number"}
        value={charityNumber}
        onChange={(e) => setCharityNumber(e.target.value)}
        example={"123456"}
      />
      <div className="flex flex-row w-full items-end justify-end">
        <RaindropButton
          title={"Create"}
          onClick={onCreate}
          style={ButtonStyle.Primary}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

const ManualNewOrganisationForm = () => {
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [website, setWebsite] = useState("");
  const [sortCode, setSortCode] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [charityNumber, setCharityNumber] = useState("");
  const [australianBusinessNumber, setAustralianBusinessNumber] = useState("");
  const [organisationType, setOrganisationType] = useState(
    "ORGANISATION_TYPE__CHARITY"
  );
  const [organisationEmail, setOrganisationEmail] = useState("");
  const [organisationAddressLine1, setOrganisationAddressLine1] = useState("");
  const [organisationAddressCity, setOrganisationAddressCity] = useState("");
  const [organisationAddressPostcode, setOrganisationAddressPostcode] =
    useState("");

  const [isLoading, setIsLoading] = useState(false);

  let randomInteger = Math.floor(Math.random() * 1000);
  let randomName = `Jägerbomb Organisation ${randomInteger}`;
  let randomEmail = `jagerbomb.${randomInteger}@example.com`;

  const onCreate = () => {
    setIsLoading(true);

    fetchGraphQL(`
      mutation {
        organisationCreate(
          name: "${name}",
          urlWebsite: "${website}",
          accountNumber: "${accountNumber}",
          accountSortCode: "${sortCode}",
          descriptionShort: "${description}",
          ukCharityNumber:
            "${
              organisationType == "ORGANISATION_TYPE__CHARITY"
                ? charityNumber
                : ""
            }",
          auAustralianBusinessNumber: 
            "${
              organisationType == "ORGANISATION_TYPE__CHARITY"
                ? australianBusinessNumber
                : ""
            }",
          organisationEmail: "${organisationEmail}",
          organisationAddressLine1: "${organisationAddressLine1}",
          organisationAddressCity: "${organisationAddressCity}",
          organisationAddressPostcode: "${organisationAddressPostcode}",
          organisationType: "${organisationType}",
        ) {
          id
        }
      } 
    `).then((response) => {
      if (response.errors) {
        console.log(response.errors);
        setIsLoading(false);
        return;
      }

      navigate(`/nimbus/organisations/${response.data.organisationCreate.id}`);
    });
  };

  return (
    <>
      <RaindropInputDropdown
        label={"Type"}
        value={organisationType}
        onChange={(e) => setOrganisationType(e.target.value)}
        options={[
          ["ORGANISATION_TYPE__CHARITY", "Charity"],
          ["ORGANISATION_TYPE__PERSON", "Person"],
        ]}
      />

      <RaindropInput
        example={randomName}
        placeholder={"Name"}
        value={name}
        onChange={(e) => setName(e.target.value)}
        label={"Name"}
      />
      <RaindropInput
        placeholder={"Website"}
        label={"Website"}
        example={"https://www.theraindropcompany.com"}
        value={website}
        onChange={(e) => setWebsite(e.target.value)}
      />
      <RaindropInput
        label={"Email"}
        example={randomEmail}
        value={organisationEmail}
        onChange={(e) => setOrganisationEmail(e.target.value)}
      />
      <RaindropInputTextArea
        label={"Description"}
        value={description}
        onChange={(e) => setDescription(e.target.value)}
        example="We are a group of people who love Jägerbombs. We are the best at making them and we want to share our knowledge with the world."
      />
      <RaindropInput
        label={"Sort Code"}
        value={sortCode}
        onChange={(e) => setSortCode(e.target.value)}
        example={"108800"}
      />
      <RaindropInput
        label={"Account Number"}
        value={accountNumber}
        onChange={(e) => setAccountNumber(e.target.value)}
        example={"00012345"}
      />
      {organisationType == "ORGANISATION_TYPE__CHARITY" && (
        <FlexCol className="border p-4 rounded-lg">
          <RaindropInput
            label={"UK Charity Number"}
            value={charityNumber}
            onChange={(e) => setCharityNumber(e.target.value)}
            example={""}
          />
          {isProductionEnvironment() && (
            <RaindropInput
              label={"Australian Business Number"}
              value={australianBusinessNumber}
              onChange={(e) => setAustralianBusinessNumber(e.target.value)}
              example={"93003884991"}
            />
          )}
        </FlexCol>
      )}

      <RaindropInput
        label={"Address Line 1"}
        value={organisationAddressLine1}
        onChange={(e) => setOrganisationAddressLine1(e.target.value)}
        example={"address_full_match"}
      />
      <RaindropInput
        label={"City"}
        value={organisationAddressCity}
        onChange={(e) => setOrganisationAddressCity(e.target.value)}
        example={"London"}
      />
      <RaindropInput
        label={"Postcode"}
        value={organisationAddressPostcode}
        onChange={(e) => setOrganisationAddressPostcode(e.target.value)}
        example={"SW1A 1AA"}
      />

      <div className="flex flex-row w-full items-end justify-end">
        <RaindropButton
          title={"Create"}
          onClick={onCreate}
          style={ButtonStyle.Primary}
          isLoading={isLoading}
        />
      </div>
    </>
  );
};

const NimbusOrganisationsNew = () => {
  const [isIngesting, setIsIngesting] = useState(false);
  const [isManual, setIsManual] = useState(false);

  return (
    <div className="flex flex-col h-full w-full items-center  text-center gap-2 overflow-auto p-4">
      <div
        className={`flex flex-col gap-4 max-w-3xl w-full p-4 rounded-lg border 
      dark:bg-color-dark-background-secondary bg-color-background-secondary
      dark:border-color-dark-border-tertiary border-color-border-tertiary
      `}
      >
        <div
          className={`w-full text-lg font-bold text-left 
        dark:text-color-dark-text-secondary text-color-text-secondary
        `}
        >
          Create an Organisation
        </div>

        <RaindropButton
          title={"Toggle Manual"}
          onClick={() => {
            setIsManual(!isManual);
          }}
        />

        {!isManual && <FormNewOrganisationIngesting />}

        {isManual && <ManualNewOrganisationForm />}
      </div>
    </div>
  );
};

export default NimbusOrganisationsNew;
